import React from 'react'
import {
  CompanyAdjustBalanceData,
  useCompanyBalanceAdjust,
} from '../../../../../../services/api/companies'
import { FormikHelpers } from 'formik'
import { isValidationError } from '../../../../../../services/api/client/types'
import { View } from './View'
import { notification } from 'antd'

const DEFAULT_AMOUNT = '1000'
type Form = CompanyAdjustBalanceData
type Props = {
  companyId: string
  onSuccess?: () => void
}

export const Container: React.FunctionComponent<Props> = ({
  companyId,
  onSuccess,
}) => {
  const [adjustCompanyBalance] = useCompanyBalanceAdjust(companyId)

  const onSubmit = (form: Form, { setErrors }: FormikHelpers<Form>) => {
    return adjustCompanyBalance(form)
      .then(() => {
        notification.success({
          message: 'Баланс успешно пополнен',
          duration: 3,
        })
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch((error) => {
        notification.error({
          message: 'Возникли ошибки при пополнении баланса',
          duration: 3,
        })
        if (isValidationError(error)) {
          setErrors(error.fieldErrors)
        }
      })
  }

  return (
    <View
      initialValues={{
        amount: DEFAULT_AMOUNT,
        comment: '',
      }}
      onSubmit={onSubmit}
    />
  )
}
